import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Typography } from '@mui/material';

export interface SelectionIndicatorProps {
  selectedCount: number;
  selectAll: boolean;
  showConnections?: boolean;
}

export const SelectionIndicator = ({ selectedCount, selectAll, showConnections = true }: SelectionIndicatorProps) => {
  if (selectAll) {
    return (
      <Typography variant="body2" color="primary">
        <FormattedMessage id="reporting.allSelected" />
      </Typography>
    );
  }

  if (selectedCount === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        <FormattedMessage id="reporting.noSelection" />
      </Typography>
    );
  }

  return (
    <Typography variant="body2" color="primary">
      <FormattedMessage
        id={showConnections ? 'reporting.selectedCount' : 'reporting.selectedCountEmployers'}
        values={{ count: selectedCount }}
      />
    </Typography>
  );
};
